import { useCallback, useState } from "react";

/**
 * Whether the editor is open, and nothing else.
 *
 * Adding is the only thing it does, so there is nothing to say about it
 * beyond that. A saved change is applied where it is made rather than held
 * here waiting to be confirmed - the dates already say when it takes
 * effect, so there is nothing for a holding state to add.
 */
export const useParentEditor = () => {
  const [editorOpen, setEditorOpen] = useState(false);

  return {
    editorOpen,
    openEditor: useCallback(() => setEditorOpen(true), []),
    closeEditor: useCallback(() => setEditorOpen(false), []),
  };
};
